import { Routes } from "@angular/router";
import { authGuard } from "@shared/guards/auth/auth.guard";

export const routes: Routes = [
    {
        path: "",
        loadChildren: () => import("./layouts/main/main.routes").then((m) => m.mainRoutes),
        canActivate: [authGuard]
    },
    {
        path: "login",
        loadChildren: () => import("./layouts/auth/auth.routes").then((m) => m.authRoutes),
    },
    {
        path: "**",
        redirectTo: "/login",
        pathMatch: "full"
    },
];
